// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleErrors = (response: Response): Promise<any> => {
  if (!response.status || response.status === 204) {
    return Promise.resolve({});
  }

  if (response.ok) {
    return response.json();
  }

  return response
    .json()
    .then((json) => {
      if (json.non_field_errors) {
        throw Error(json.non_field_errors[0]);
      } else if (json.error) {
        throw Error(json.error);
      } else if (json.Error) {
        throw Error(json.Error);
      } else if (json.errors) {
        throw Error(json.errors);
      } else if (json.detail) {
        throw Error(json.detail);
      } else if (json[0]) {
        throw Error(json[0]);
      } else {
        throw Error(response.statusText);
      }
    })
    .catch((err) => {
      throw err;
    });
};

export default handleErrors;
